<template>
  <div class="game-page">
    <div class="game-nav van-nav-bar" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left">
          <img src="/img/game/logo2.png" alt="logo" class="nav-logo">
        </div>
        <div class="van-nav-bar__title van-ellipsis">{{ $t('foorter.video') }}</div>
      </div>
    </div>

    <div class="game-body">
      <ul class="ddd ddd2">
        <li
          class="game-card"
          v-for="(v, key) in gameitem"
          :key="key"
          @click="toLottery(v.key, v.id)"
        >
          <div class="game-card-inner">
            <div
              class="game-card-cover"
              :style="{ backgroundImage: 'url(' + getCardImg(v, key) + ')' }"
            ></div>
            <div class="card-badge">
              <img src="/img/game/qy.png" alt="">
              <span>會員權益</span>
            </div>
            <p class="card-title">{{ lang == 'en' ? (v.name_es || v.name) : v.name }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      gameitem: [],
      lotteryitem: [],
      isLoading: false,
      lang: localStorage.getItem("lang") || "hk",
      activeKey: 0,
      localCovers: [
        "/img/game/46b8214d20fe68029ac3909b26f82122.jpg",
        "/img/game/1e30baaa5970ac5503b65760d33f450b.jpg",
        "/img/game/f86a7a3c98f966d0829cebaef3a13016.jpg",
        "/img/game/27217b734ab57ad22c9810976733d53a.jpg"
      ]
    };
  },
  methods: {
    getCardImg(v, key) {
      if (v && v.ico && !v.ico.startsWith('http')) {
        return v.ico;
      }
      if (v && v.ico && v.ico.startsWith('http')) {
        // 如果数据库传过来的是旧域名，替换为本地图片
        return this.localCovers[key % 4];
      }
      return v && v.img ? v.img : this.localCovers[key % 4];
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id });
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        if (res && res.data) {
          this.gameitem = res.data;
        }
      });
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        if (res && res.data) {
          this.lotteryitem = res.data;
        }
      });
    }
  },
  created() {
    this.getGameItem();
    this.getLotteryItem();
  }
};
</script>

<style scoped>
.game-page {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 120px;
  background: #f3f3f5;
  box-sizing: border-box;
}

.game-nav {
  position: relative;
  height: 100px;
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% auto;
}

::v-deep .game-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .game-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 700 !important;
  line-height: 100px !important;
}

.nav-logo {
  width: 160px;
  height: auto;
  display: block;
}

.game-body {
  width: 92%;
  margin: 0 auto;
  padding-bottom: 40px;
}

.ddd {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 30px;
  margin: 0;
  list-style: none;
}

.ddd:after {
  content: "";
  width: 48%;
  height: 0;
}

.ddd li.game-card {
  width: 48%;
  aspect-ratio: 1;
  margin: 0 0 30px;
  padding: 4px;
  border-radius: 20px;
  background: linear-gradient(135deg, #4f2b8a, #f560cd);
  box-sizing: border-box;
  cursor: pointer;
}

.game-card-inner {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
}

.game-card-cover {
  position: absolute;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  width: 48%;
  aspect-ratio: 1;
  border-radius: 14px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  z-index: 0;
}

.card-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 22px;
  line-height: 1.4;
  border-radius: 8px;
  padding: 4px 12px;
  background: rgba(101, 41, 201, 0.85);
}

.card-badge img {
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 8px;
}

.card-title {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  margin: 0;
  padding: 16px 20px;
  font-size: 26px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.65));
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
